import { isReactive, toRaw } from 'vue';

import i18n from '@/i18n';


const isObjectWithData = instance => {
	if (instance == null) {
		return false;
	}
	return !(
		Object.keys(instance).length === 0 &&
		instance.constructor === Object
	);
};

const updateObject = (target, source) => {
	const keys = Object.keys(target).filter(value => Object.keys(source).includes(value));
	for (let key of keys) {
		target[key] = source[key]
	}
};

const findItem = (items, value, key, defaultValue) => {
	const found = items.filter(item => item[key] === value);
	if (found.length === 0) {
		return defaultValue;
	}
	return found[0];
}


const sortArrayByFieldAccordingToValuesOrder = (source, field, valuesOrder) => {
	const sortedArray = [...source];
	sortedArray.sort((a, b) => {
		const indexA = valuesOrder.indexOf(a[field]);
		const indexB = valuesOrder.indexOf(b[field]);
		if (indexA === -1 && indexB === -1) {
			return 0;
		} else if (indexA === -1) {
			return 1;
		} else if (indexB === -1) {
			return -1;
		} else {
			return indexA - indexB;
		}
	});
	return sortedArray;
};


const toObject = value => {
	if (isReactive(value)) {
		return { ...toRaw(value) }
	}
	return value;
}

const applyFunctionToFields = (value, fields, func) => {
	let result = { ...value };
	for (let field of fields) {
		func(result, field);
	}
	return result;
}


const objectStringPropSorter = field => {
	return (a, b) => a[field].localeCompare(b[field]);
}


const formatFractions = digits => {
	return value => (new Intl.NumberFormat(i18n.global.locale.value, {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	})).format(value);
}


const safeTrim = (value, defaultValue) => {
	if (value == null) {
		if (defaultValue !== undefined) {
			return defaultValue;
		}
		return value;
	}
	return String(value).trim();
}

const formatMilliMetres = formatFractions(0);
const formatLatLong = formatFractions(2);
const formatMetres = formatFractions(3);


const linearDependence = (argMin, argMax, valueMin, valueMax) => {
	return arg => {
		const kappa = (valueMax - valueMin) / (argMax - argMin);
		const result = kappa * arg + valueMax - kappa * argMax;
		const realMin = Math.min(valueMin, valueMax);
		const realMax = Math.max(valueMin, valueMax);
		return Math.max(Math.min(realMax, result), realMin);
	}
}


const toRubles = value => Math.round(value / 100);


export default {
	isObjectWithData,
	updateObject,
	findItem,
	sortArrayByFieldAccordingToValuesOrder,
	toObject,
	applyFunctionToFields,
	objectStringPropSorter,
	safeTrim,
	formatFractions,
	formatMilliMetres,
	formatLatLong,
	formatMetres,
	linearDependence,
	toRubles,
}
